import AccordionComponent from '@common/scripts/components/accordionComponent';
export default class StoneAccordion extends AccordionComponent {
    constructor(element) {
        super(element);
        this.initAccordion();
    }
    toggleAccordion(e, el) {
        e.preventDefault();
        if (el.getAttribute(this.ATTRIBUTES.isExpanded) == 'true') {
            el.setAttribute(this.ATTRIBUTES.isExpanded, 'false');
        }
        else {
            el.setAttribute(this.ATTRIBUTES.isExpanded, 'true');
        }
    }
}
